<template>
    <div class="w-full p-0 mb-8">
        <div class="summary-container flex bg-white flex-row content-between p-4">
            <div class="flex w-full">
                <div class="flex flex-grow text-xl justify-start items-center p-4 text-center">
                    <span v-if="customer.likelihood != 'Unknown'">
                        <strong class="text-viva-money-black">{{ customer.forename | capitalize }}</strong>, it looks like you have a <strong>{{ customer.likelihood }}</strong> chance of finding your loan with us today.
                    </span>
                    <span v-else>
                        <strong class="text-viva-money-black">{{ customer.forename | capitalize }}</strong>, your chances are unknown right now. Don’t worry, we still find 4/5 customers a loan.
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {  
    props: ['customer'],
}
</script>

<style lang="scss" scoped>

</style>